(function () {
	const productSlider = () => {
		$(document).ready(function () {
			$(".js-get-section").each(function (index, parent) {
				let parentId = `#${$(parent).attr("id")}`;

				let carousel = document
					.querySelector(parentId)
					.querySelector(`.js-swiper-product-carousel`);

				let scrollBar = document
					.querySelector(parentId)
					.querySelector(`.js-product-carousel-swiper-scrollbar`);

				let prev = document
					.querySelector(parentId)
					.querySelector(`.js-product-carousel-arrow-prev`);

				let next = document
					.querySelector(parentId)
					.querySelector(`.js-product-carousel-arrow-next`);

				// Initialisation de Swiper
				let swiperCarousel = new Swiper(carousel, {
					slidesPerView: 6, // 4 produits visibles
					spaceBetween: 10, // Espacement entre les produits
					centeredSlides: true, // Centrer les slides
					loop: true, // Activer la boucle infinie
					scrollbar: {
						el: scrollBar,
						draggable: true,
					},
					navigation: {
						prevEl: prev,
						nextEl: next,
					},
					breakpoints: {
						0: { slidesPerView: 1.5 }, // 1,5 produits visibles sur mobile
						750: { slidesPerView: 3 }, // 3 produits sur tablette
						1200: { slidesPerView: 4 }, // 4 produits sur desktop
					},
				});

				// Mise à jour des classes des slides
				const updateSlideClasses = () => {
					swiperCarousel.slides.forEach((slide) => {
						// Vérifie si la slide est visible ou non
						if (slide.classList.contains("swiper-slide-visible")) {
							slide.classList.remove("is-outside");
						} else {
							slide.classList.add("is-outside");
						}
					});
				};

				// Écoute les événements Swiper
				swiperCarousel.on("slideChange", updateSlideClasses);
				swiperCarousel.on("resize", updateSlideClasses);

				// Initialisation des classes au chargement
				updateSlideClasses();
			});
		});
	};

	document.addEventListener("DOMContentLoaded", function () {
		productSlider();
		document.addEventListener("shopify:section:load", function () {
			productSlider();
		});
	});
})();




